import type { TJSONSchema } from "@artifact-management/json-dynamic-form";
import { TextField } from "@mui/material";
import { Controller, type FieldValues, type Path, type PathValue } from "react-hook-form";
import type { IFormGenInputProps } from "./index";

export const FormGenInputText = <Schema extends TJSONSchema, T extends FieldValues>({
  control,
  uiSchemaElement,
  multiple,
}: IFormGenInputProps<Schema, T>) => {
  if (multiple) {
    throw new Error("Multiple text input is not supported yet");
  }

  return (
    <Controller
      control={control}
      name={uiSchemaElement.scope as unknown as Path<T>}
      defaultValue={"" as unknown as PathValue<T, Path<T>>}
      render={({ field, fieldState }) => (
        <TextField
          label={uiSchemaElement.label}
          value={field.value}
          onChange={field.onChange}
          onBlur={field.onBlur}
          error={Boolean(fieldState.error)}
          helperText={fieldState.error?.message}
          inputRef={field.ref}
          size="small"
          fullWidth
          disabled={uiSchemaElement.disabled}
        />
      )}
    />
  );
};
